/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetMeResp } from './GetMeResp';
import {
    GetMeRespFromJSON,
    GetMeRespFromJSONTyped,
    GetMeRespToJSON,
    GetMeRespToJSONTyped,
} from './GetMeResp';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetMe200Response
 */
export interface GetMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GetMeResp}
     * @memberof GetMe200Response
     */
    result: GetMeResp;
}

/**
 * Check if a given object implements the GetMe200Response interface.
 */
export function instanceOfGetMe200Response(value: object): value is GetMe200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetMe200ResponseFromJSON(json: any): GetMe200Response {
    return GetMe200ResponseFromJSONTyped(json, false);
}

export function GetMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMe200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GetMeRespFromJSON(json['result']),
    };
}

export function GetMe200ResponseToJSON(json: any): GetMe200Response {
    return GetMe200ResponseToJSONTyped(json, false);
}

export function GetMe200ResponseToJSONTyped(value?: GetMe200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': GetMeRespToJSON(value['result']),
    };
}

